export const urlTitle2 = (title) => {
  const cyrilic = ["č", "ć", "ž", "š", "đ", ",", ":", "-", "?", "!", "."];
  const replArray = ["c", "c", "z", "s", "dj", "", "", "", "", "", ""];
  let regex = /--/gi;
  let url_title = title
    .toLowerCase()
    .split("")
    .map((x) => {
      return cyrilic.indexOf(x) === -1 ? x : replArray[cyrilic.indexOf(x)];
    })
    .join("")
    .split(" ")
    .join("-")
    .replace(regex, "-");
  return url_title;
};

export const id2 = (pathPart) => {
  const labels = {
    subvencije: "Subvencije",
    "produktna-berza": "Produktna berza",
    vinoteka: "Vinoteka",
  };
  // console.log("PathPart", pathPart);

  if (pathPart[1] === "vinoteka") {
    return labels[pathPart[1]] || null;
  } else {
    return labels[pathPart[2]] || null;
  }
};
export const setSource = (item) => {
  if (Array.isArray(item)) {
    return `Autor: ${item[1]}`;
  } else {
    return `Izvor: ${item}`;
  }
};

export const getPreUrlTitle = (item, allC, cat = false) => {
  const found = allC.find((e) => urlTitle2(e.title) === urlTitle2(item.category));
  const route = found?.route;
  return route ? `${route}${cat ? "" : urlTitle2(item.title) + "/"}` : "";
};

export const sortByDate = (item1, item2) => {
  const date1 = new Date(item1.modified || item1.time2);
  const date2 = new Date(item2.modified || item2.time2);
  return date2 - date1;
};

export const formatTime2 = (postTime, showYear = true) => {
  const months = ["januar", "februar", "mart", "april", "maj", "jun", "jul", "avgust", "septembar", "oktobar", "novembar", "decembar"];

  const postDate = new Date(postTime);
  if (isNaN(postDate)) return "";

  const date = postDate.getDate();
  const month = months[postDate.getMonth()];
  const year = postDate.getFullYear();

  return showYear ? `${date}. ${month} ${year}.` : `${date}. ${month}`;
};

export const structuredData = (post, dimensions) => {
  const jsonLd = JSON.stringify({
    "@context": "https://schema.org",
    "@type": "NewsArticle",
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": `https://agroweb.rs${window.location.pathname}`,
    },
    headline: post.title_2 || post.title,
    description: post.lead_2 || post.lead||"",
    image: {
      "@type": "ImageObject",
      url: post.pics[0],
      width: dimensions?.width || 1200, // ako koristiš useImageSize
      height: dimensions?.height || 675,
    },
    datePublished: post.time2,
    dateModified: post.modified || post.time2,
    author: {
      "@type": "Person",
      name: (setSource(post.source) || "Redakcija").replace(/^Autor:\s*/, ""),
    },
    publisher: {
      "@type": "Organization",
      name: "Agroweb.rs",
      logo: {
        "@type": "ImageObject",
        url: "https://res.cloudinary.com/dvi29tcsc/image/upload/v1750335367/agroweb/logo_fkunfx.png",
        width: 870,
        height: 359,
      },
    },
  });
  // return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: jsonLd }} />;
  return jsonLd;
};
